import { render } from "./Cookies.vue?vue&type=template&id=28f25efc&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=28f25efc&lang=scss"
import "./Cookies.vue?vue&type=style&index=1&id=28f25efc&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2146743556/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f25efc"]])

export default __exports__